import { Component, Input } from '@angular/core';

interface OverviewRow {
  label: string;
  value: string;
  badge?: string;
  loading?: boolean;
}

@Component({
  selector: 'app-environment-overview',
  templateUrl: './environment-overview.component.html',
  styleUrls: ['./environment-overview.component.scss'],
  standalone: false
})
export class EnvironmentOverviewComponent {
  @Input() instance: any = null;
  @Input() blueprintName?: string;
  @Input() solutionName?: string;
  @Input() releaseVersion?: string;
  @Input() environmentName?: string;
  @Input() envClass?: string;
  @Input() isAMR = false;                       
  @Input() instanceLoading = true;
  @Input() solutionLoading = true;

  readonly supportUrl = 'http://saas.support.temenos.com/';

    get rows(): OverviewRow[] {
        const i = this.instance;
        return [
            { label: 'Release', value: this.releaseVersion || 'N/A', loading: this.solutionLoading},
            { label: 'Status', value: i?.status ? this.titleCase(i.status) : '-', loading: this.solutionLoading },
            { label: 'Created Date', value: this.formatDate(i?.dateCreated), loading: this.solutionLoading},
            { label: 'Updated Date', value: this.formatDate(i?.dateUpdated), loading: this.solutionLoading },
            { label: 'Modified By', value: this.formatDate(i?.modifiedBy), loading: this.solutionLoading}
        ];
    }

  openTicket(): void {
    window.open(this.supportUrl, '_blank');
  }

  private titleCase(v: string): string {
    return v.charAt(0).toUpperCase() + v.slice(1).toLowerCase();
  }

  private formatDate(value?: string): string {
    if (!value) { return '-'; }
    const d = new Date(value.endsWith('Z') || /[+-]\d\d:?\d\d$/.test(value) ? value : value + 'Z');
    if (isNaN(d.getTime())) { return '-'; }
    const date = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
    const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC' });
    return `${date}, ${time} UTC`;
  }
}